import downArrow from '../../assets/images/down-arrow.svg';
import React from 'react'
import './DownArrow.css'

const DownArrow = () => {


    return (
        <div className="downarrow">
            <img src={downArrow} alt="" />
        </div>
    )
}

export default DownArrow
